/**
 * Webhooks API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createWebhook,
  deleteWebhook,
  getWebhookById,
  getWebhooks,
  rotateWebhookSecret,
  testWebhook,
  updateWebhook,
} from "../generated/webhooks/webhooks";

import { wrapListMethod, wrapMethod } from "./utils";

export const webhooks = {
  /** @see createWebhook */
  create: wrapMethod(createWebhook),

  /** @see getWebhooks */
  list: wrapListMethod(getWebhooks),

  /** @see getWebhookById */
  get: wrapMethod(getWebhookById),

  /** @see updateWebhook */
  update: wrapMethod(updateWebhook),

  /** @see deleteWebhook */
  delete: wrapMethod(deleteWebhook),

  /** @see testWebhook */
  testWebhook: wrapMethod(testWebhook),

  /** @see rotateWebhookSecret */
  rotateWebhookSecret: wrapMethod(rotateWebhookSecret),
} as const;

export type WebhooksApi = typeof webhooks;
